import { useTranslation } from "react-i18next";
import ProjectFormLayout from "layouts/ProjectFormLayout";
import { ProjectDto } from "common/dtos/ProjectDto";
import Select from "components/Select";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import NewRoleForm from "./NewRoleForm";

interface ProjectRolesProps {
  projectData: ProjectDto;
  setProjectData: Dispatch<SetStateAction<ProjectDto>>;
}

const ProjectRoles = ({ projectData, setProjectData }: ProjectRolesProps) => {
  const { t, i18n } = useTranslation("project");
  const [selected, setSelected] = useState<string>("");

  const getRoleNames = () => {
    return projectData?.roles.map((role) => role.name);
  };

  // only way so far to set this initial value
  // and making it change based on selected lang
  useEffect(() => {
    setSelected(t("createRole"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  return (
    <ProjectFormLayout title={t("addRoles")}>
      <Select
        selected={selected}
        options={[t("createRole"), ...getRoleNames()]}
        handleChange={setSelected}
        hightlightFirstOption
      />
      <NewRoleForm projectData={projectData} setProjectData={setProjectData} />
    </ProjectFormLayout>
  );
};

export default ProjectRoles;
